module.exports = __webpack_public_path__ + "media/fonts/ProximaNova-RegularIt-93576342.woff2";